import React from "react"

const LoadingDots = () => {
  return (
    <div className="loading-dots">
      <div className="dot dot1"></div>
      <div className="dot dot2"></div>
      <div className="dot dot3"></div>
    </div>
  )
}

export default LoadingDots
